export default __webpack_public_path__ + "static/media/search.66b44a5e.svg";